import * as angular from "angular";

export class MapHelperService {
    private root: string;
    private reverseRoot: string;
    private stateRoot: string;
    private $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.root = "/v2/geocode/locate";
        this.reverseRoot = "/v2/geocode/reverse";
        this.stateRoot = "/v2/geocode/state";
    }

    locateAddress(address: any, success: Function, failure: Function): any {
        this.$http({
            method: "GET",
            url: this.root,
            params: {
                address: address,
            },
            withCredentials: false,
        }).then(
            (response: object) => {
                if (
                    response["data"].success &&
                    response["data"].data.hlocationtype !== "ZERO_RESULTS"
                ) {
                    return success({
                        locationtype: response["data"].data.hlocationtype,
                        coords: {
                            latitude: response["data"].data.hlatitude,
                            longitude: response["data"].data.hlongitude,
                        },
                    });
                } else {
                    return failure(response["data"].data);
                }
            },
            (error: object) => failure(error["data"])
        );
    }

    reverseGeocode(
        latitude: number,
        longitude: number,
        success: Function,
        failure: Function
    ): any {
        this.$http({
            method: "GET",
            url: this.reverseRoot,
            params: {
                latitude: latitude,
                longitude: longitude,
            },
            withCredentials: false,
        }).then(
            (response: object) => {
                if (response["data"].success) {
                    return success(response["data"].data);
                } else {
                    return failure(response["data"].data);
                }
            },
            (error: object) => failure(error["data"])
        );
    }

    suggestedState(
        latitude: number,
        longitude: number,
        success: Function,
        failure: Function
    ): any {
        this.$http({
            method: "GET",
            url: this.stateRoot,
            params: {
                latitude: latitude,
                longitude: longitude,
            },
            withCredentials: false,
        }).then(
            (response: object) => {
                if (response["data"].success) {
                    return success(response["data"].data);
                } else {
                    return failure(response["data"].data);
                }
            },
            (error: object) => failure(error["data"])
        );
    }
}
angular.module("map").service("MapHelperService", MapHelperService);
